module.exports = __webpack_public_path__ + "img/report-logo.a1ea4acf.png";